const escapeHtml = (value) =>
  String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");

export const parseStructuredDocument = (value, fallback = {}) => {
  if (typeof value !== "string") return value || fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const structuredDocumentHtml = (node) => {
  if (!node) return "";
  if (node.type === "text") {
    let value = escapeHtml(node.text || "");
    (node.marks || []).forEach((mark) => {
      if (mark.type === "bold") value = `<strong>${value}</strong>`;
      if (mark.type === "italic") value = `<em>${value}</em>`;
      if (mark.type === "underline") value = `<u>${value}</u>`;
      if (mark.type === "textStyle" && mark.attrs?.fontSize)
        value = `<span style="font-size:${mark.attrs.fontSize}">${value}</span>`;
    });
    return value;
  }
  if (node.type === "hardBreak") return "<br>";
  const children = (node.content || []).map(structuredDocumentHtml).join("");
  const alignment = node.attrs?.textAlign || "left";
  if (node.type === "paragraph")
    return `<p style="text-align:${alignment}">${children}</p>`;
  if (node.type === "heading") {
    const level = node.attrs?.level === 3 ? 3 : 2;
    return `<h${level} style="text-align:${alignment}">${children}</h${level}>`;
  }
  if (node.type === "listItem") return `<li>${children}</li>`;
  if (node.type === "bulletList") return `<ul>${children}</ul>`;
  if (node.type === "orderedList") {
    const start = node.attrs?.start > 1 ? ` start="${node.attrs.start}"` : "";
    const type = node.attrs?.type ? ` type="${node.attrs.type}"` : "";
    return `<ol${start}${type}>${children}</ol>`;
  }
  if (node.type === "blockquote")
    return `<blockquote style="border-left:3px solid #52c2bd;margin:16px 0;padding:4px 0 4px 16px;color:#527c79">${children}</blockquote>`;
  return children;
};
